<mat-dialog-content>
  <iframe *ngIf="safeVideoUrl" width="560" height="315" [src]="safeVideoUrl" frameborder="0" allowfullscreen></iframe>
  <div *ngIf="!safeVideoUrl" class="error-message">
    <p>Invalid video URL.</p>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button matDialogClose>Close</button>
</mat-dialog-actions>